export default __webpack_public_path__ + "static/EngraversGothic-18cec203e60c5017261c29c113f07cdc.ttf";